import { render } from "./GameEdit.vue?vue&type=template&id=30bd5fd3"
import script from "./GameEdit.vue?vue&type=script&lang=js"
export * from "./GameEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__